<template>
  <div class="contact-outer">
    <div class="contact-title">联系我们</div>
    <div class="contact-desp">当您需要我们的时候，其实我们一直都在您的身边</div>
    <div class="contact-line"/>
    <ContactItem v-for="(contact, index) in contacts" :key="index" :contact="contact"/>
  </div>
</template>

<script>
  import ContactItem from './ContactItem'
  export default {
    name: 'Contact',
    components: {ContactItem},
    data() {
      return {
        contacts: [
          {
            iconUrl: require('../assets/images/contact1.png'),
            title: '联系电话',
            content: '13173683686'
          },
          {
            iconUrl: require('../assets/images/contact2.png'),
            title: '邮箱',
            content: '815490449@qq.com'
          },
          {
            iconUrl: require('../assets/images/contact4.png'),
            title: '微信',
            content: '13173683686'
          },
          {
            iconUrl: require('../assets/images/contact3.png'),
            title: 'QQ',
            content: '815490449'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .contact-outer {
    margin-top: 7.1875vw;
    padding-bottom: 5.208vw;
  }

  .contact-title {
    font-family: PingFangSC-Semibold;
    font-size: 3.125vw;
    color: #1158E8;
    text-align: center;
  }

  .contact-desp {
    font-family: PingFangSC-Regular;
    font-size: 1.042vw;
    color: #999999;
    text-align: center;
    line-height: 1.5625vw;
    margin-top: 0.8854vw;
  }

  .contact-line {
    width: 5.677vw;
    height: 0.3125vw;
    background-color: #1158E8;
    margin: 3.4375vw auto 7.604vw auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactPanel.vue